<template>
  <div class="true-false-field col-12 mb-3">
    <div class="row no-gutters">
      <div class="col-12 col-xl-4 pr-xl-3">
        <Field
          type="select"
          label="Correct Answer *"
          name="field_answer"
          v-model="selected"
          :options="options"
          :hideSelectEmptyOption="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    answer: { type: String, default: "T" }
  },
  data() {
    return {
      selected: "T"
    };
  },
  computed: {
    options() {
      return [
        { label: "True", value: "T" },
        { label: "False", value: "F" }
      ];
    }
  },
  watch: {
    answer(val) {
      this.selected = val;
    },
    selected(val) {
      this.$emit("answer", val);
    }
  },
  mounted() {
    this.selected = this.answer || "T";
  }
};
</script>